var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-text"},_vm._l((_vm.blocksContent),function(block){return _c('span',[(block.url)?_c('url-visualisation',{attrs:{"url":block.url,"html":block.html}}):_c('span',{domProps:{"innerHTML":_vm._s(block.html)}})],1)}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cfa3c8e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageVisualisation.vue
// module id = Xjpc
// module chunks = 1